import UIIconButton from 'UIComponents/button/UIIconButton';
import UIIcon from 'UIComponents/icon/UIIcon';
import { theme } from 'academy-common-lib/utils/Styling';
import { useDevtools, useShowDevtools } from '../devtoolsQueries';
import { jsx as _jsx } from "react/jsx-runtime";
export const DevtoolsButton = () => {
  const {
    toggle
  } = useDevtools();
  const showDevtools = useShowDevtools();
  if (!showDevtools) return null;
  return /*#__PURE__*/_jsx(UIIconButton, {
    onClick: toggle,
    use: "transparent",
    children: /*#__PURE__*/_jsx(UIIcon, {
      color: theme.colors.OLAF,
      name: "settings"
    })
  });
};